import { type AlertProps, Alert as BaseAlert } from '@shared/ui-components';

import { useGlobalCmsContentContext } from '../providers/global-cms-context';

export const Alert = (props: AlertProps) => {
  const { cmsContent } = useGlobalCmsContentContext();

  return <BaseAlert {...props} closeButtonLabel={cmsContent.closeButtonLabel} />;
};
